import React from "react";

import styles from "./ModalCard.module.css";
import classNames from "classnames";

//Card with background and padding used inside of modals
export function ModalCard({ children, className = "" }) {
  return (
    <div className={classNames(styles.modalCard, className)}>{children}</div>
  );
}
